import { find } from "lodash";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AdminPage } from "../../App/layout/AdminPage/AdminPage";
import { Tag } from "../../App/components/atoms";

const currentMenu = [
  {
    key: "privateYachts",
    label: "Private Yachts",
    link: `/booking/private-yachts`,
  },
  {
    key: "groupYachts",
    label: "Group yachts",
    link: `/booking/group-yachts`,
  },
  {
    key: "cars",
    label: "Cars",
    link: `/booking/cars`,
  },
  {
    key: "airplanes",
    label: "Airplanes",
    link: `/booking/airplanes`,
  },
  {
    key: "extras",
    label: "Extras",
    link: `/booking/extras`,
  },
];
const currentBreadcrumb = (name: string) => [
  {
    key: "page",
    label: name,
    link: "#",
  },
];
const BookingPage: React.FC = () => {
  const location = useLocation();
  const [pageName, setPageName] = React.useState<string>("");
  const [breadcrumb, setBreadcrumb] = React.useState<any[]>([]);
  React.useEffect(() => {
    const name = find(currentMenu, ["link", location.pathname]);
    setBreadcrumb(currentBreadcrumb(name?.label || "") || []);
    setPageName(name?.label || "");
  }, [location.pathname]);
  return (
    <AdminPage
      title={
        <div className="admin-page-title">
          Booking <Tag>{pageName}</Tag>{" "}
        </div>
      }
      headerMenu={currentMenu}
      breadcrumb={breadcrumb}
    >
      <Outlet />
    </AdminPage>
  );
};

export default BookingPage;
